import React from "react";
import styled from "styled-components";
const Wrapper = styled.aside`
  display: flex;
  flex-direction: column;
  position: relative;
`;
const DefaultSideBar = () => {
  return /*#__PURE__*/React.createElement(Wrapper, null);
};
export default DefaultSideBar;